import React, { Component } from 'react';

import { Card, Row, Col } from 'react-bootstrap'

import GetPdf from '../get-pdf'

import i18n from "../../../i18n";

const titleStyle = {
    backgroundColor: "#003366",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px"
}

const marginRemove = {
    marginLeft: "0px",
    marginRight: "0px"
}

const padding = {
    padding: "15px"
}

const atrwithValue = "col-lg-6 col-sm-12 col-12 border"
const atrOrValue = "col-lg-6 col-sm-6 col-6"

export default class DocumentInformation extends Component {

    constructor(props) {
        super(props);
        this.triggerChildGetPdf = this.triggerChildGetPdf.bind(this);
    }

    triggerChildGetPdf() {
        this.refs.diagnosticChild.handleDownload(2, this.props.language);
    }

    render() {

        return (
            <React.Fragment>

                <Card.Header style={titleStyle} >
                    {i18n.t("docInfo:document_information")}
                </Card.Header>

                <Row style={marginRemove}>
                    <Col style={padding} className="col-lg-12 col-sm-12 col-12 border">
                        <Row>
                            <Col className="col-lg-3 col-sm-6 col-6">{i18n.t("docInfo:document_name")}</Col>
                            <Col className="col-lg-9 col-sm-6 col-6" style={{ "wordWrap": "break-word" }}> {this.props.documentName}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row style={marginRemove}>
                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_generation_time")}</Col>
                            <Col className={atrOrValue} >{this.props.reportGenerationTime}</Col>
                        </Row>
                    </Col>

                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:num_of_signatures")}</Col>
                            <Col className={atrOrValue} >{this.props.signatures.length}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row style={marginRemove}>
                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_avalible_on")}</Col>
                            <Col className={atrOrValue} >
                                <div onClick={() => this.triggerChildGetPdf()}>
                                    <GetPdf ref="diagnosticChild" hash={this.props.hash} linkId={this.props.linkId} documentName={this.props.documentName} reportType={3} button={true}/>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_avalible_until")}</Col>
                            <Col className={atrOrValue} >{this.props.permLinkValidUntil}</Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}